// extracted by mini-css-extract-plugin
export default {"root":"J0WtK","priority-primary":"_1Xbg9","priorityPrimary":"_1Xbg9","priority-secondary":"tZ4hu","prioritySecondary":"tZ4hu"};